import { render } from "./ActivityRecap.vue?vue&type=template&id=4dd189d8&scoped=true"
import script from "./ActivityRecap.vue?vue&type=script&lang=js"
export * from "./ActivityRecap.vue?vue&type=script&lang=js"

import "./ActivityRecap.vue?vue&type=style&index=0&id=4dd189d8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd189d8"]])

export default __exports__